export const APA_ROLL_BACK_LIST_REQUEST = 'APA_ROLL_BACK_LIST_REQUEST';
export const APA_ROLL_BACK_LIST_SUCCESS = 'APA_ROLL_BACK_LIST_SUCCESS';
export const APA_ROLL_BACK_LIST_FAIL    = 'APA_ROLL_BACK_LIST_FAIL';
